<template>
    <div class="login-wrapper">
        <div class="login-box">
            <el-form class="login-form bg-white">
                <h4>{{setting.web_title}}</h4>
                <el-form-item prop="username">
                    <el-input v-model="item.username">
                        <template #prefix>
                            <el-icon class="el-input__icon el-icon-user"></el-icon>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" v-model="item.password">
                        <template #prefix>
                            <el-icon class="el-input__icon el-icon-lock"></el-icon>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="isLoad" class="login-btn" type="primary" @click="submit">登录</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script scoped>
    export default {
        name: 'Login',
        data() {
            return {
                item: {
                    username: '',
                    password: ''
                },
                isLoad: false,
                setting: {
                    web_title: '供应商登陆'
                },
                logining: false
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            loadData() {

            },
            submit() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/supplier/user/login', this.item)
                    .then(res => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '登录成功',
                            showClose: false
                        });
                        localStorage.token = res.data.token
                        localStorage.login_name = res.data.username
                        let redirect = this.$route.query.redirect
                        if (!redirect)
                            redirect = '/'
                        this.$router.replace({path: redirect});
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped lang="less">
    .bg-white{
        background: #ffffff;
    }
    .login-wrapper {
        padding: 50px 20px;
        position: relative;
        box-sizing: border-box;
        background-image: url("../assets/images/login-bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        min-height: 100vh;
    }

    .login-form {
        margin: 0 auto;
        width: 360px;
        max-width: 100%;
        padding: 25px 30px;
        position: relative;
        box-shadow: 0 3px 6px rgba(0, 0, 0, .15);
        box-sizing: border-box;
        border-radius: 4px;
        z-index: 2;
    }

    .el-input__icon {
        font-size: 14px;
    }

    .login-form h4 {
        text-align: center;
        margin: 0 0 25px 0;
    }

    .login-form > .el-form-item {
        margin-bottom: 25px;
    }

    .login-input-group {
        display: flex;
        align-items: center;
    }

    .login-captcha {
        height: 38px;
        width: 102px;
        margin-left: 10px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        text-align: center;
        cursor: pointer;
    }

    .login-btn {
        display: block;
        width: 100%;
    }

    .login-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);

        .login-form {
            margin-top: -50%;
        }
    }
</style>
